// extracted by mini-css-extract-plugin
export var card_icon_box = "card_icon_box-46v";
export var size_large = "size_large-8kt";